<h3-toggle-button-group
  [vertical]="true"
  [ngModel]="getSelectedToolStore().$ | async"
  (ngModelChange)="selectTool($event, { source: 'button' })"
  [buttons]="buttons"
></h3-toggle-button-group>
